
<div class="bottom-sheet">
    <div> {{ 'The form has been changed, are you sure you want to close it?' | translate }} </div>
    <button mat-raised-button type="button" cdkFocusInitial #btnFocus color="warn" (click)="close()">{{ "Close" | translate }}</button>
    <button mat-raised-button class="change" type="submit" color="primary" (click)="continue()">{{ "Continue" | translate }}</button>
</div>